import angular from 'angular';
import ComponentsModule from '../components-module';

const COMPONENT_NAME = 'CloneContentService';

angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, (
    $location,
    Application,
    AuthenticationService,
    ContentEditor,
    ContentService,
    RecentContentService,
    WorkspaceService
  ) => {
    return {
      clone: (alias) => {
        let workspaceName;

        AuthenticationService.getCurrentUser ()
          .then ((user) => {
            workspaceName = user.userId + '-workspace';
            
            return ContentService.getContent ({ alias, fullTypeInfo: true });
          })
          .then ((contentResult) => {
            return ContentEditor.onContentClone (contentResult.content);
          })
          .then ((contentClone) => {
            // Clear some product aspects if they exist

            if (contentClone.aspects.aceSlugInfo) {
              contentClone.aspects.aceSlugInfo = { _type: 'aceSlugInfo' };
            }

            if (contentClone.aspects.aceImporterChecksum) {
              delete contentClone.aspects.aceImporterChecksum;
            }

            if (contentClone.status) {
              delete contentClone.status;
            }

            return WorkspaceService.createContent ({
              workspace: workspaceName,
              fullTypeInfo: true,

              content: {
                aspects: contentClone.aspects,
                system: contentClone.system
              }
            });
          })
          .then ((createResult) => {
            let cloneAlias = atex.aceui.ObjectUtils.getByPath (createResult, 'content/system/id');

            RecentContentService.addContent (cloneAlias, false, true);
            $location.search ({ cloneOf: alias }).path (`/edit/${cloneAlias}`);
          })
          .catch ((error) => {
            console.error ('ERROR: ', error);

            Application.currentErrorInfo = { error: error };
            $location.path ('/error').replace ();
          });
      }
    };
  });

export default COMPONENT_NAME;
